import * as React from 'react';

function SvgPlusIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <circle cx={10} cy={10} r={10} fill="#0C3998" />
      <g stroke="#fff" strokeLinecap="round" strokeWidth={2}>
        <path d="m10 6 .085 8M6 10l8 .085" />
      </g>
    </svg>
  );
}
export default SvgPlusIcon;
